__turbopack_context__.v({
  "controls": "CpuBound-module__L3qija__controls",
  "hint": "CpuBound-module__L3qija__hint",
  "modeBadge": "CpuBound-module__L3qija__modeBadge",
  "modeLegend": "CpuBound-module__L3qija__modeLegend",
  "modeOption": "CpuBound-module__L3qija__modeOption",
  "modePicker": "CpuBound-module__L3qija__modePicker",
  "panel": "CpuBound-module__L3qija__panel",
  "panelBadge": "CpuBound-module__L3qija__panelBadge",
  "panelBudget": "CpuBound-module__L3qija__panelBudget",
  "panelChecksum": "CpuBound-module__L3qija__panelChecksum",
  "panelHeader": "CpuBound-module__L3qija__panelHeader",
  "panelMeta": "CpuBound-module__L3qija__panelMeta",
  "panelPending": "CpuBound-module__L3qija__panelPending",
  "panelTitle": "CpuBound-module__L3qija__panelTitle",
  "panels": "CpuBound-module__L3qija__panels",
  "root": "CpuBound-module__L3qija__root",
  "themeButton": "CpuBound-module__L3qija__themeButton",
  "themeButtonSelected": "CpuBound-module__L3qija__themeButtonSelected",
  "themeLabel": "CpuBound-module__L3qija__themeLabel",
  "themePicker": "CpuBound-module__L3qija__themePicker",
});
